import type { Contact, ContactDraft, ContactDraftErrors } from '../../../types/InfrastructureManagerTypes';
import { CONTACT_VALIDATION_MESSAGES, EMAIL_PATTERN, NON_DIGITS, PHONE_DIGITS } from './constants';

export const toPhoneDigits = (value: string) => value.replace(NON_DIGITS, '');

export const toDraft = (contact: Contact): ContactDraft => ({
  name: contact.name,
  email: contact.email,
  // Stored numbers may carry formatting (e.g. "+1 (555) 123-4567"); the form edits digits only.
  phone: toPhoneDigits(contact.phone),
  company: contact.company ?? '',
  role: contact.role ?? '',
  notes: contact.notes ?? '',
});

export const trimDraft = (draft: ContactDraft): ContactDraft => ({
  name: draft.name.trim(),
  email: draft.email.trim(),
  phone: draft.phone.trim(),
  company: draft.company.trim(),
  role: draft.role.trim(),
  notes: draft.notes.trim(),
});

export const validateDraft = ({ name, email, phone }: ContactDraft) => {
  const errors: ContactDraftErrors = {};
  if (!name) errors.name = CONTACT_VALIDATION_MESSAGES.NAME_REQUIRED;
  if (!email) errors.email = CONTACT_VALIDATION_MESSAGES.EMAIL_REQUIRED;
  else if (!EMAIL_PATTERN.test(email)) errors.email = CONTACT_VALIDATION_MESSAGES.EMAIL_INVALID;
  if (!phone) errors.phone = CONTACT_VALIDATION_MESSAGES.PHONE_REQUIRED;
  else if (phone.length !== PHONE_DIGITS) errors.phone = CONTACT_VALIDATION_MESSAGES.PHONE_LENGTH;
  return errors;
};

// Failures are already toasted by useContacts; this only reports whether to close the UI.
export const didSucceed = (request: Promise<unknown>) =>
  request.then(
    () => true,
    () => false,
  );
